import React, { useState } from 'react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="w-full  top-0 left-0 z-20 bg-white h-auto border-b border-gray-200">
      <div className="container mx-auto px-6 lg:px-8 py-2 h-full flex justify-between items-center">
           <button 
  onClick={() => window.history.back()} href="/" className="flex items-center">
  <img 
    src="https://www.welcomheritagehotels.in/images/wh-logo.png" 
    alt="WelcomHeritage Hotels" 
    className="h-20 w-auto object-contain"
  />
</button>
        
        <nav className="hidden lg:flex items-center space-x-8">
          {/* <a href="#" className="text-sm font-normal text-text-secondary hover:text-brand-accent transition-colors duration-200">Home</a>
          <a href="#" className="text-sm font-normal text-text-secondary hover:text-brand-accent transition-colors duration-200">Help</a>
          <a href="#" className="text-text-secondary hover:text-brand-accent transition-colors duration-200">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </a> */}
        </nav>
        
        {/* <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="lg:hidden text-text-secondary hover:text-brand-accent focus:outline-none"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-7 h-7">
            {mobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            )}
          </svg>
        </button> */}
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="absolute top-16 left-0 w-full bg-white shadow-lg lg:hidden z-10 border-t border-gray-200">
          <nav className="flex flex-col p-4 space-y-2">
            <a href="#" className="block px-4 py-2 text-base font-medium text-text-secondary hover:bg-gray-100 hover:text-brand-accent rounded-md transition-colors duration-200">Home</a>
            <a href="#" className="block px-4 py-2 text-base font-medium text-text-secondary hover:bg-gray-100 hover:text-brand-accent rounded-md transition-colors duration-200">Help</a>
            <a href="#" className="block px-4 py-2 mt-2 text-base font-medium text-text-secondary hover:bg-gray-100 hover:text-brand-accent rounded-md transition-colors duration-200 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              My Account
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;